import { render, staticRenderFns } from "./BuildingEditReportsTab.vue?vue&type=template&id=5e1f2da4"
import script from "./BuildingEditReportsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditReportsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports